<ng-container *ngIf="currentUserWrapper$ | async as currentUserWrapper; else loadingTemplate">
  <ng-container *ngIf="!loadingOffers; else loadingTemplate">
    <ng-container
      [ngTemplateOutlet]="offerGroupTemplate"
      [ngTemplateOutletContext]="{ offerGroup: acceptedOfferGroup }"
    ></ng-container>

    <ng-container
      [ngTemplateOutlet]="offerGroupTemplate"
      [ngTemplateOutletContext]="{ offerGroup: pendingOfferGroup }"
    ></ng-container>

    <ng-container
      *ngIf="showRejectedAndRetractedOffers"
      [ngTemplateOutlet]="offerGroupTemplate"
      [ngTemplateOutletContext]="{ offerGroup: rejectedOfferGroup }"
    ></ng-container>

    <ng-container
      *ngIf="showRejectedAndRetractedOffers"
      [ngTemplateOutlet]="offerGroupTemplate"
      [ngTemplateOutletContext]="{ offerGroup: retractedOfferGroup }"
    ></ng-container>

    <button
      *ngIf="offerGroupHasOffers(rejectedOfferGroup) || offerGroupHasOffers(retractedOfferGroup)"
      (click)="showRejectedAndRetractedOffers = !showRejectedAndRetractedOffers"
      class="btn btn-link link-primary w-100"
    >
      <ng-container *ngIf="!showRejectedAndRetractedOffers">
        {{ "Show rejected/retracted offers" | translate }}
      </ng-container>

      <ng-container *ngIf="showRejectedAndRetractedOffers">
        {{ "Hide rejected/retracted offers" | translate }}
      </ng-container>
    </button>

    <ng-template #offerGroupTemplate let-offerGroup="offerGroup">
      <ng-container *ngFor="let group of offerGroup | keys">
        <div *ngIf="group.value.length > 0" class="offer card mb-4">
          <div class="card-header">
            <ng-container *ngIf="group.value[0].user !== currentUserWrapper.user?.id">
              <h4>
                {{ "Offer" | translate }}
              </h4>

              <h5>
                <a
                  [href]="
                    userService.getGalleryUrl(
                      group.value[0].userObj.username,
                      !currentUserWrapper.userProfile || currentUserWrapper.userProfile.enableNewGalleryExperience
                    )
                  "
                  (click)="
                    userService.openGallery(
                      group.value[0].userObj.username,
                      !currentUserWrapper.userProfile || currentUserWrapper.userProfile.enableNewGalleryExperience
                    )
                  "
                  astrobinEventPreventDefault
                >
                  {{ group.value[0].userDisplayName }}
                </a>
              </h5>

              <astrobin-marketplace-feedback-widget
                *ngIf="group.value[0].user !== currentUserWrapper.user?.id"
                [listing]="listing"
                [user]="group.value[0].userObj"
                class="d-inline-block ms-2"
              ></astrobin-marketplace-feedback-widget>
            </ng-container>

            <ng-container *ngIf="group.value[0].user === currentUserWrapper.user?.id">
              {{ "My offer" | translate }}
            </ng-container>

            <div class="offer-info">
              <p>{{ "Created" | translate }}: {{ group.value[0].created | localDate | timeago }}</p>

              <p>
                {{ "Status" | translate }}: {{ equipmentMarketplaceService.humanizeOfferStatus(group.value[0].status) }}
              </p>
            </div>
          </div>

          <div class="card-body">
            <ul>
              <ng-container *ngFor="let offer of group.value">
                <ng-container *ngIf="getLineItem(offer.lineItem) as lineItem">
                  <li>
                    <div class="item-name">{{ lineItem.itemName }}</div>
                    <span class="amount">{{ offer.amount | currency: lineItem.currency }}</span>
                    <span *ngIf="!!lineItem.shippingCost" class="shipping">
                      + {{ "shipping" | translate }}: {{ lineItem.shippingCost | currency: lineItem.currency }}
                    </span>
                  </li>
                </ng-container>
              </ng-container>
            </ul>
          </div>
          <!-- card-body -->

          <ng-container *ngIf="listing.user === currentUserWrapper.user?.id">
            <div class="card-footer d-flex flex-column gap-2">
              <ng-container *ngIf="!equipmentMarketplaceService.listingSold(listing)">
                <button
                  *ngIf="group.value[0].status === MarketplaceOfferStatus.PENDING"
                  [class.loading]="loadingService.loading$ | async"
                  (click)="onAcceptOfferClicked($event, group.value)"
                  class="btn btn-success d-block w-100 m-0"
                >
                  <fa-icon icon="thumbs-up"></fa-icon>
                  {{ "Accept" | translate }}
                </button>

                <button
                  *ngIf="
                    group.value[0].status === MarketplaceOfferStatus.PENDING ||
                    group.value[0].status === MarketplaceOfferStatus.ACCEPTED
                  "
                  [class.loading]="loadingService.loading$ | async"
                  (click)="onRejectOfferClicked($event, group.value)"
                  class="btn btn-danger d-block w-100 m-0"
                >
                  <fa-icon icon="thumbs-down"></fa-icon>
                  {{ "Reject" | translate }}
                </button>
              </ng-container>

              <button
                [class.loading]="loadingService.loading$ | async"
                (click)="onMessageProspectBuyerClicked($event, group.value[0].user)"
                class="btn btn-secondary d-block w-100 m-0"
              >
                <fa-icon icon="envelope"></fa-icon>
                <ng-container
                  *ngIf="
                    group.value[0].status === MarketplaceOfferStatus.ACCEPTED &&
                      group.value[0].lineItemObj.reserved &&
                      group.value[0].lineItemObj.reservedTo === group.value[0].user &&
                      !group.value[0].lineItemObj.sold;
                    else normalMessageLabel
                  "
                >
                  {{ "Exchange payment/delivery info" | translate }}
                </ng-container>
                <ng-template #normalMessageLabel>
                  {{ "Message" | translate }}
                </ng-template>
              </button>
            </div>
            <!-- card-footer -->
          </ng-container>

          <ng-container
            *ngIf="
              !equipmentMarketplaceService.listingSold(listing) &&
              group.value[0].user === currentUserWrapper.user?.id &&
              group.value[0].status !== MarketplaceOfferStatus.REJECTED &&
              group.value[0].status !== MarketplaceOfferStatus.RETRACTED
            "
          >
            <div class="card-footer">
              <button
                *ngIf="group.value[0].status === MarketplaceOfferStatus.PENDING"
                [class.loading]="loadingService.loading$ | async"
                (click)="onModifyOfferClicked($event, group.value)"
                class="btn btn-link link-secondary d-block"
              >
                <fa-icon icon="edit"></fa-icon>
                {{ "Modify" | translate }}
              </button>

              <button
                *ngIf="
                  group.value[0].status === MarketplaceOfferStatus.ACCEPTED ||
                  group.value[0].status === MarketplaceOfferStatus.PENDING
                "
                [class.loading]="loadingService.loading$ | async"
                (click)="onRetractOfferClicked($event, group.value)"
                class="btn btn-link link-danger"
              >
                <fa-icon icon="times"></fa-icon>
                {{ "Retract" | translate }}
              </button>
            </div>
            <!-- card-footer -->
          </ng-container>
        </div>
      </ng-container>
    </ng-template>
  </ng-container>
</ng-container>

<ng-template #loadingTemplate>
  <p class="d-block w-100 text-center">{{ "Loading offers..." | translate }}</p>
  <astrobin-loading-indicator></astrobin-loading-indicator>
</ng-template>
